import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import { noop } from 'ui-components/default-props/noop';
import Global from '../../../../store/global-selectors';
import { useVisiblePackingSlips } from '../../../../hooks/use-visible-packing-slips';
import { SimpleDropdown } from '../../../simple-dropdown';

const messages = defineMessages({
  defaultLabel: {
    description: 'packingSlipTemplateDropdownContainer.defaultLabel',
    defaultMessage: 'Packing Slip Template',
    id: 'zfYTke',
  },
  defaultTitle: {
    description: 'packingSlipTemplateDropdownContainer.defaultTitle',
    defaultMessage: 'Select Template',
    id: 'Dgxbnq',
  },
});

export const PackingSlipTemplateDropdown = ({
  dropdownMenuShouldHaveWidthOfButton = false,
  onItemSelected = noop,
  required = false,
  selectedPackingSlipTemplateId = '',
  hasError = false,
}) => {
  const label = <FormattedMessage {...messages.defaultLabel} />;
  const defaultTitle = <FormattedMessage {...messages.defaultTitle} />;

  const sellerPackingSlipFormat = useSelector((state) => Global.selectSellerSellerSetting(state, { settingName: 'PSFormat' }));
  const sellerPackingSlips = useVisiblePackingSlips();
  const packingSlips = sellerPackingSlips.filter((slip) => sellerPackingSlipFormat && sellerPackingSlipFormat.includes(slip.size));
  const items = packingSlips.map(({ name, packingSlipId }) => ({
    name,
    key: packingSlipId,
  }));

  return (
    <SimpleDropdown
      defaultTitle={defaultTitle}
      dropdownMenuShouldHaveWidthOfButton={dropdownMenuShouldHaveWidthOfButton}
      hasError={hasError}
      items={items}
      label={label}
      onItemSelected={onItemSelected}
      required={required}
      selectedItemKey={selectedPackingSlipTemplateId}
    />
  );
};

PackingSlipTemplateDropdown.propTypes = {
  dropdownMenuShouldHaveWidthOfButton: PropTypes.bool,
  onItemSelected: PropTypes.func,
  required: PropTypes.bool,
  selectedPackingSlipTemplateId: PropTypes.string,
  hasError: PropTypes.bool,
};
